export const ID_MAX_LEN = 50;



// WEBPACK FOOTER //
// ./src/constants/numbers.js